import { createAsyncThunk } from "@reduxjs/toolkit";
import { BackOfficeDetailsConstant, ProfileInformationConstant } from "../../constants";
import NeweraRequestService from "services/newera/neweraRequestService";
import { buildErrorDisplayMessage } from "utils/errorMessageBuilder";

export const updateBackOfficeDetails = createAsyncThunk(
  `${ProfileInformationConstant.StoreSliceName}/updateBackOfficeDetails`,
  async (payload, {rejectWithValue }) => {
    try {
      const result =  await NeweraRequestService.updateBackOfficeDetails(payload);
      return result
    } catch (error) {
      const errorDisplayMessage = buildErrorDisplayMessage(error);
      throw rejectWithValue(errorDisplayMessage);
    }
  }
);
